import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import { Helmet } from 'react-helmet';
import LocalizedStrings from 'react-localization';
import { FooterModule, AppsBannerModule, Page404Module } from 'polisua-react-modules/index.esm';
import {createBrowserHistory} from 'history';
import HeaderContainer from './containers/HeaderContainer';
import KascoFind from './views/KascoFind';
import KascoList from './views/KascoList';
import KascoItem from './containers/KaskoItemContainer';
import CompareView from './views/CompareView';
import ApplyView from './views/ApplyView';
import ErrorBoundary from './components/ErrorBoundary';
import { KaskoService } from './services/kaskoService';
import queryString from 'query-string';
import Wrapper from './components/Wrapper';
import BreadcrumbsWrapper from './components/BreadcrumbsWrapper';
import SeoBlock from './components/SeoBlock';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locale: ''
    };
    // google tag manager id
    this.gtmId = 'GTM-WNCBJN4';
    this.kaskoService = new KaskoService();
    this.history = createBrowserHistory();
  }

  componentDidMount = () => {
    TagManager.initialize({ gtmId: this.gtmId });
    this.initAdmitad();

    if (this.history.location.pathname.includes('/uk/kasko')) {
      this.setLanguageUA();
    } else {
      this.setLanguageRU();
    }
  }

  setLanguageUA = () => {
    this.setState({
      locale: 'ua',
    });
  }

  setLanguageRU = () => {
    this.setState({
      locale: 'ru',
    });
  }

  addToDataLayer = (pathEnd = '') => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'Pageview',
        url: `${this.history.location.pathname}${pathEnd}`
      }
    });
  }

  initAdmitad = () => {
    const params = queryString.parse(this.history.location.search);
    const { initCookie } = this.kaskoService;

    if (params.admitad_uid) {
      initCookie(params.admitad_uid)
        .then(() => console.log('Cookie set!'))
        .catch(() => console.log('Cookie set error!'));
    }
  }

  redirectTo404 = (history) => {
    const url = this.state.locale === 'ua' ? '/uk/kasko' : '/kasko';
    history.push(url);
  }

  render() {
    const { locale } = this.state;

    return (
      <ErrorBoundary locale={locale}>
        <Router history={this.history}>
          <div id="main">
            <Wrapper locale={locale}>
              <HeaderContainer
                setLanguageUA={this.setLanguageUA}
                setLanguageRU={this.setLanguageRU}
                locale={locale}
              />
              <BreadcrumbsWrapper locale={locale} />
              <Switch>
                <Route exact path={'/(uk)?/kasko'} component={() => <KascoFind locale={locale} addToDataLayer={this.addToDataLayer} />} />
                <Route exact path={'/(uk)?/kasko/list'} component={() => <KascoList locale={locale} addToDataLayer={this.addToDataLayer} />} />
                <Route exact path={'/(uk)?/kasko/info'} component={() => <KascoItem locale={locale} addToDataLayer={this.addToDataLayer} />} />
                <Route exact path={'/(uk)?/kasko/compare'} component={() => <CompareView locale={locale} addToDataLayer={this.addToDataLayer} />} />
                <Route exact path={'/(uk)?/kasko/apply'} component={() => <ApplyView locale={locale} addToDataLayer={this.addToDataLayer} />} />
                <Route render={(props) => <Page404Module lang={locale === 'ua' ? 'uk' : 'ru'} onButtonClick={() => this.redirectTo404(props.history)} />} />
              </Switch>
            </Wrapper>
            <AppsBannerModule lang={locale === 'ua' ? 'uk' : 'ru'} />
            <SeoBlock locale={locale} />
            <FooterModule lang={locale === 'ua' ? 'uk' : 'ru'} />
          </div>
        </Router>
      </ErrorBoundary>
    );
  }
}

export default App;
